import React, { Suspense, lazy } from 'react';
import { useAuth } from '@/hooks/useAuth';

const RealTwilioProvider = lazy(() =>
  import('./TwilioContext').then((m) => ({ default: m.TwilioProvider })),
);

/**
 * Lazily mounts the real TwilioProvider (and its heavy @twilio/voice-sdk chunk)
 * only after the user is authenticated. On /auth or while auth is loading, we
 * render children directly — no consumer of useTwilio() exists outside
 * authenticated routes, so this is safe.
 */
export function TwilioProvider({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading || !user) {
    return <>{children}</>;
  }

  return (
    <Suspense fallback={<>{children}</>}>
      <RealTwilioProvider>{children}</RealTwilioProvider>
    </Suspense>
  );
}
